import CastingEntity, { CastingEntityOptions } from "./CastingEntity"

export type PlayerOptions = { playerName?: string } & CastingEntityOptions

export default class Player extends CastingEntity {

	playerName

	constructor({ playerName = 'Player', ...rest }: PlayerOptions) {
		super({
			...rest,

			symbol: '🎭'
		})

		this.evented = true
		this.playerName = playerName
	}


	getName() {
		return this.playerName
	}
}